const AmazonCognitoIdentity = require("amazon-cognito-identity-js")

const poolData = {
  UserPoolId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID,
  ClientId: process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID,
}

export const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData)
